

export class AddAdCampaignDto {
    name!: string;
}